import React, { useEffect, useState } from "react";
import svg95 from "../../../assets/svg/svg95.svg";
import svg89 from "../../../assets/svg/svg89.svg";
import svg91 from "../../../assets/svg/svg91.svg";
import { useDispatch, useSelector } from "react-redux";
import { dateForHumans, formatText, numberWithCommas } from "../../../utils";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import { setActiveObj } from "../../../features/folder/folderSlice";
import ShareJobModal from "../../recruitment/jobs/add/modal/ShareJobModal";

function ViewCard() {
  const dispatch = useDispatch();
  const { activeObjJob } = useSelector((state) => ({
    activeObjJob: state.folder.activeObj["job"],
  }));
  const url = "api/v1/jobs/getAll";
  const status = activeObjJob?.jobAdvertStatus;
  const statusColors = {
    PUBLISH: "#569D6E",
    RE_ADVERTISE: "#DAA520",
    ARCHIEVE: "#706F6F",
    CANCEL: "#FDB505",
    DRAFT: "#706F6F",
  };

  const [openMarks, setOpenMarks] = useState(false);
  const handleOpenMarks = async (item) => {
    await setOpenMarks(true);
  };
  const handleCloseMarks = async () => {
    await setOpenMarks(false);
  };

  useEffect(() => {
    const jobId = window.location.hash.split("/shared-job/")[1]?.split("/")[0];

    async function fetchJobById(id) {
      try {
        const resp = await axios.post(
          "https://recruitment.ndovuhr.com/api/v1/jobs/getAll",
          { jobId: id }
        );
        console.log("resp", resp.data.data.result?.[0]);

        const jobData = resp?.data?.data?.result?.[0];
        if (jobData) {
          dispatch(setActiveObj({ key: "job", data: jobData }));
        }
      } catch (error) {
        toast.error("Error fetching job by ID");
      }
    }

    if (jobId && !activeObjJob) {
      fetchJobById(jobId);
    }
  }, [activeObjJob]);

  return (
    <>
      <div className="job-pic-public p-[2.5rem] rounded-[10px] z-[1000] mt-[-1.2rem]">
        <div className="flex justify-between flex-shrink flex-wrap lg:items-center font-dmSans">
          <div className="text-[2rem] font-[500] text-[#000] ">
            {activeObjJob?.jobTitle}
          </div>
          <div className="flex items-center gap-[1rem]">
            <span
              className="inline-block w-fit max-w-full py-[.25rem] px-[.5rem] rounded-[2.1875rem] text-xs font-normal  
              bg-[#E8EEED]"
              style={{ color: statusColors[status] || "#000" }}
            >
              {formatText(status)}
            </span>

            <div className="flex items-center gap-[.5rem] font-[400] text-[.875rem] text-[#000] cursor-pointer" onClick={handleOpenMarks}>
              <img src={svg95} alt="svg95" />
              Share Job
            </div>
          </div>
        </div>

        <div className="mt-[.69rem]  flex items-center">
          <span className="text-[#000] font-dmSans text-[1rem] font-[400]">
            Majani Sacco
          </span>
          {!activeObjJob?.jobSalaryConfidentiality && (
            <>
              <span className="text-[#16A34A] text-[1rem] font-[600] ml-1">
                {activeObjJob?.jobCurrency}{" "}
                {numberWithCommas(activeObjJob?.jobGrossPay)}
              </span>
              <span className="text-[#7C7C7C] text-[.75rem] font-[400]">
                /{activeObjJob?.jobPayFrequency}
              </span>
            </>
          )}
        </div>

        <div className="flex flex-shrink flex-wrap lg:items-center lg:space-x-4 gap-3 text-[#000] text-[.75rem] font-[400] mt-[1.5rem]">
          <div className="flex items-center space-x-1">
            <img src={svg89} alt="svg89" />
            <span>{activeObjJob?.jobCity}</span>
          </div>

          <div className="flex items-center gap-[.5rem]">
            <img src={svg91} alt="svg91" />
            <span>{activeObjJob?.jobEmploymentTerms}</span>
          </div>

          <div className="flex items-center gap-[.5rem]">
            <img src={svg91} alt="svg91" />
            <span>{activeObjJob?.jobApplicantCount} applied</span>
          </div>

          <div className="flex items-center gap-[.5rem]">
            <img src={svg91} alt="svg91" />
            <span>
              {activeObjJob?.jobCurrency}{" "}
              {numberWithCommas(activeObjJob?.jobGrossPay)}/
              {activeObjJob?.jobPayFrequency}
            </span>
          </div>

          <div className="flex items-center gap-[.5rem] text-[#000] text-[1rem] font-[400] font-dmSans">
            Closing
            <span> {dateForHumans(activeObjJob?.jobAdvertEndDate)}</span>
          </div>
        </div>
      </div>

      <ShareJobModal
        open={openMarks}
        handleCancel={handleCloseMarks}
        activeObjJob={activeObjJob}
      />
    </>
  );
}

export default ViewCard;
